import React from 'react'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import PaginationComponent from './../../../../../components/pagination/pagination.component'
import { ClientReportsService } from './../../../../../services/client-reports.service'
import { ClientTicketService } from './../../../../../services/client-ticket.service'
import { canShowPixQrCode } from './pix-qr-code.helper'
import styled from 'styled-components'

const StyledSpan = styled.span`
	&:hover {
		.fa {
			transition: all 0.5s;
			color: #666 !important;
		}
	}
`

class PurchasePagination extends React.Component {
	componentWillReceiveProps(nextProps) {
		if (nextProps.forceReloadData !== this.props.forceReloadData) {
			this.refs.pagination.reload()
		}
	}
	render() {
		return (
			<PaginationComponent
				ref="pagination"
				headers={headers}
				rowsPerPage={10}
				params={this.props.params}
				getData={this.getData}
				renderRow={(rowData) => renderRow(rowData, this.props)}
			/>
		)
	}

	/**
	 * Intercepta a resposta so para avisar a pagina sobre o estado do historico do legado
	 * (carregado ou nao, e desde quando). O PaginationComponent ignora as chaves que nao
	 * conhece, entao nao precisa mudar — e a pagina nao precisa repetir a requisicao.
	 */
	getData = (params) =>
		ClientReportsService.searchPurchases(params).then((resposta) => {
			const { onLegacySyncChange } = this.props
			if (onLegacySyncChange) onLegacySyncChange(resposta.legacySync)
			return resposta
		})
}

function formatDateTime(date) {
	return date ? moment(date).format('DD/MM/YYYY HH:mm') : '-'
}

// Spec 056 (US6): "Em análise" NAO entra aqui de proposito. Esta lista pinta a
// linha como cancelada, e o pedido em analise nao esta cancelado - o valor do
// cliente continua conosco, aguardando atendimento. Cor neutra e o certo.
const CANCELED_STATUSES = ['Falhou', 'Cancelado', 'Reembolsado']

// Exportada só pra teste (purchase-pagination.component.test.jsx) — a função em si nunca toca
// PaginationComponent/Table, é pura o suficiente pra ser montada isolada numa <table> de teste.
export function renderRow(rowData, props) {
	return headers.map(({ key, align }) => {
		const isCanceled = CANCELED_STATUSES.includes(rowData.status)
		const showQrCode = canShowPixQrCode(rowData)
		// FR-001: a contagem de bilhetes é informação do detalhe, não permissão de navegação.
		// Toda linha exibida precisa ser clicável — quem decide o que mostrar (inclusive pedido
		// sem bilhete emitido ainda) é o detalhe, que já sabe fazer isso (ver FR-002).
		const onClickRow = () => {
			props
				.getPurchaseTickets(rowData.id, {
					orderNumber: rowData.orderNumber,
					status: rowData.status,
					dateCreated: rowData.dateCreated,
					paymentType: rowData.paymentType,
				})
				.then(props.openClientTicketModal)
				// Onda 2: a falha já foi comunicada (toast) pelo duck (client-ticket-modal.js).
				// Aqui só evita a rejeição não tratada e garante que o modal não abra sem dado.
				.catch(() => {})
		}
		const onClickQrCode = () => {
			// A falha (Pix vencido → 410, já pago → 404) já vira toast com a mensagem da API.
			ClientTicketService.getPix(rowData.id).then(props.openQrCodeModal).catch(() => {})
		}

		switch (key) {
			case 'dateCreated':
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span>{formatDateTime(rowData[key])}</span>
					</td>
				)
			case 'paymentType':
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span>{rowData.paymentType}</span>
					</td>
				)
			case keys.STATUS:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={rowData.status} className={isCanceled ? 'danger' : ''}>
							{rowData.status}
						</span>
					</td>
				)
			case keys.VALUE: {
				const valorFormatado = Number(rowData.value).toLocaleString('pt-BR', {
					style: 'currency',
					currency: 'BRL',
				})

				// Bug 7905: compra com pontos cobra pouco ou nada em dinheiro — mostrar só o valor
				// monetário fazia um resgate de 12.270 pontos aparecer como "R$ 0,00", indistinguível de
				// uma gratuidade. Os pontos entram na frente e o valor real em reais continua ao lado
				// (inclusive R$ 0,00, que é o que de fato foi cobrado).
				const pontos = Number(rowData.points) || 0
				const valorExibido =
					pontos > 0
						? `${pontos.toLocaleString('pt-BR')} pts + ${valorFormatado}`
						: valorFormatado

				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={valorExibido}>{valorExibido}</span>
					</td>
				)
			}
			case keys.ACTIONS:
				return (
					<td key={key} align={align}>
						{showQrCode && (
							<StyledSpan
								title="Exibir QR Code para pagamento"
								onClick={onClickQrCode}>
								<FontAwesome name="qrcode" />
							</StyledSpan>
						)}
						{/* FR-001: o ícone segue a mesma regra da linha — sempre visível, já que o
						    detalhe agora sempre abre, com ou sem bilhete emitido. */}
						<StyledSpan
							style={{ marginLeft: showQrCode ? '1em' : 0 }}
							title="Visualizar detalhes da viagem"
							onClick={onClickRow}>
							<FontAwesome name="ticket" />
						</StyledSpan>
					</td>
				)
			default:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={rowData[key]}>{rowData[key]}</span>
					</td>
				)
		}
	})
}

const keys = {
	VALUE: 'value',
	STATUS: 'status',
	ACTIONS: 'actions',
}

const headers = [
	{ header: 'Data da compra', key: 'dateCreated', align: 'center' },
	{ header: 'Pedido', key: 'orderNumber', align: 'center' },
	{ header: 'Meio de pagamento', key: 'paymentType', align: 'center' },
	{ header: 'Valor', key: keys.VALUE, align: 'right' },
	{ header: 'Situação', key: keys.STATUS },
	{ header: 'Ações', key: keys.ACTIONS, align: 'right' },
]

export default PurchasePagination
